import { createTheme } from "@mui/material/styles";
import { colors } from "common/scss/themes";

const haistackTheme = createTheme({
  palette: {
    primary: { main: colors.primary[7], contrastText: colors.gray[1] },
    secondary: { main: "#FFFFFF" },
    success: { main: "#109363" },
    text: {
      primary: "#1a202c",
      secondary: "#6b7280"
    }
  },
  typography: {
    fontFamily: '"Noto Sans", sans-serif'
  }
});

export default haistackTheme;
